import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { DisplayProps, PositionProps, WidthProps } from 'styled-system';
import { display, position, themeGet, width } from 'styled-system';

import { HeadlineH7 } from '../../Typography';

const UnstyledTitle = styled(HeadlineH7)<
  PositionProps & DisplayProps & WidthProps & { active: boolean }
>`
  ${position};
  ${display};
  ${width};
  ${props =>
    props.active &&
    css`
      cursor: pointer;
      /* The support is not that good, but most of the modern mobile browsers are supporting this */
      /* https://caniuse.com/#feat=css-media-interaction */
      @media not all and (pointer: coarse) {
        &:hover {
          color: ${themeGet('colors.sys.primary.background.default')(props)};
        }
      }
    `};
`;

const Title = (props: ComponentProps<typeof UnstyledTitle>) => (
  <UnstyledTitle
    as="h3"
    position="relative"
    display="block"
    textAlign="left"
    width={1}
    m="sp_0"
    mb="sp_0"
    px="sp_0"
    pt="sp_16"
    pb={['sp_16', null, 'sp_8']}
    {...props}
  />
);

export default Title;
